// Every theme of `CardTheme`: the type checks that none is missing
const themes: Record<CardTheme, true> = {
    rounded: true,
    outline: true,
    pill: true,
    box: true,
    'box-translucent': true,
    'box-translucent-dark': true,
    menu: true,
    suggestion: true,
    'without-thumbnail': true,
    left: true,
    'left-center': true,
    'right-center': true,
    'over-bottom-left': true,
    'over-video': true,
    'box-bottom-left': true,
};

const aliases: Record<LegacyCardTheme, CardTheme> = {
    without_thumbnail: 'without-thumbnail',
};

const warnedThemes = new Set<string>();

/**
 * Convert the former names of a card theme (from content or code) to its current name. An unknown
 * theme is kept as is, so the card renders as before, with a warning in development.
 */
function normalizeCardTheme(
    theme: CardTheme | LegacyCardTheme | string | null = null,
): CardTheme | null {
    if (theme === null || theme === '') {
        return null;
    }
    const finalTheme = aliases[theme as LegacyCardTheme] || theme;
    if (
        process.env.NODE_ENV !== 'production' &&
        typeof themes[finalTheme as CardTheme] === 'undefined' &&
        !warnedThemes.has(finalTheme)
    ) {
        warnedThemes.add(finalTheme);
        console.warn(`Unknown card theme: ${finalTheme}`);
    }
    return finalTheme as CardTheme;
}

export default normalizeCardTheme;
